function handleUpsellATCClick(e) {
  const button = e.target.closest('.upsell-atc-btn');
  if (!button || button.classList.contains('loading')) return;

  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  button.classList.add('loading');
  button.textContent = 'Adding';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  })
    .then(() => fetch('/cart'))
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

            const updatedCartItems = doc.querySelector('cart-drawer-items');
            const currentCartItems = document.querySelector('cart-drawer-items');
            if (currentCartItems && updatedCartItems) {
                currentCartItems.innerHTML = updatedCartItems.innerHTML;
            }

            // 2. Replace the Footer (This contains your Price/Compare-at-Price logic)
            const updatedFooter = doc.querySelector('.drawer__footer');
            const currentFooter = document.querySelector('.drawer__footer');
            if (currentFooter && updatedFooter) {
                currentFooter.innerHTML = updatedFooter.innerHTML;
            }

            // 3. IMPORTANT: Remove or Comment out this loop below 
            /* const updatedTotals = doc.querySelectorAll('[data-hulkapps-cart-total]');
            const currentTotals = document.querySelectorAll('[data-hulkapps-cart-total]');
            currentTotals.forEach((el, index) => {
                if (updatedTotals[index]) el.textContent = updatedTotals[index].textContent;
            });
            */

            // 4. Force HulkApps to re-calculate (if the app is installed)
            if (window.hulkappsDoUpdate) {
                window.hulkappsDoUpdate();
            }

                  // ✅ Open cart drawer
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                    cartDrawer.dispatchEvent(new Event('open'));
                  } else {
                    const trigger = document.querySelector('[data-cart-trigger]');
                    if (trigger) trigger.click();
                  }

                  // ✅ Re-init upsell buttons after DOM change
                  setTimeout(initUpsellATC, 500);
                })
                .catch(err => {
                  console.error('Error adding upsell product to cart:', err);
                })
                .finally(() => {
                  button.classList.remove('loading');
                  button.textContent = 'Add';
                });
            }


function initUpsellATC() {
  document.querySelectorAll('.upsell-atc-btn').forEach(btn => {
    btn.removeEventListener('click', handleUpsellATCClick);
    btn.addEventListener('click', handleUpsellATCClick);
  });
}

// Retry mechanism for late-loading DOM
function waitForElements(callback) {
  const checkInterval = setInterval(() => {
    const hasUpsell = document.querySelector('.upsell-atc-btn');
    const hasCart = document.querySelector('cart-drawer') || document.querySelector('cart-items');

    if (hasUpsell && hasCart) {
      clearInterval(checkInterval);
      callback();
    }
  }, 300);

  setTimeout(() => clearInterval(checkInterval), 10000); // Stop after 10s
}

document.addEventListener('DOMContentLoaded', () => {
  waitForElements(() => {
    initUpsellATC();
  });

  // Watch for DOM changes (like upsell injected later)
  const observer = new MutationObserver(() => {
    initUpsellATC();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
